import { XIcon } from 'lucide-preact';

import { cn } from '@/lib/utils';

import AnimalAlertButton from './AnimalAlertButton';
import { ANIMAL_ALERT_TYPES, AnimalAlertType } from './constants';
import { useFlaggedAnimalAlertType } from './useFlaggedAnimalAlertType';

interface AnimalAlertMobileListProps {
  disabled?: boolean;
  habitatId: string;
  className?: string;
  onClose?: () => void;
  onSelect?: (alertType: AnimalAlertType) => void;
}

const AnimalAlertMobileList = ({
  disabled = false,
  habitatId,
  className,
  onClose,
  onSelect,
}: AnimalAlertMobileListProps) => {
  const flaggedAlertType = useFlaggedAnimalAlertType(habitatId);
  return (
    <div className={cn('flex shrink-0 flex-row items-stretch overflow-hidden rounded-full bg-white', className)}>
      <div className="flex flex-1 flex-row gap-2 overflow-auto p-0.5">
        <div className="flex shrink-0 gap-2">
          {ANIMAL_ALERT_TYPES.map((alertType) => (
            <AnimalAlertButton
              key={alertType}
              alertType={alertType}
              selected={flaggedAlertType === alertType}
              disabled={disabled}
              onClick={() => onSelect?.(alertType)}
            />
          ))}
        </div>
      </div>
      <div className="preflight flex self-stretch border-l-2 border-stone-400">
        <button
          type="button"
          className="preflight preflight-button flex items-center justify-center px-2.5 py-0.5"
          onClick={onClose}
          aria-label="Close animal alert selector"
        >
          <XIcon className="size-4 text-forest-darkest" />
        </button>
      </div>
    </div>
  );
};
export default AnimalAlertMobileList;
